export default __webpack_public_path__ + "static/3-3a7b28f75be34500637113fff7cd2216.jpeg";